import { Bodies } from "matter-js"
import scence from "./assets/map/Game Scene.png"
import cookieURL from "./assets/map/cookie.png"
import barrierURL from "./assets/map/barrier.png"
import startURL from "./assets/map/start.png"
import endURL from "./assets/map/gate.png"
import questionURL from "./assets/map/question.png"

var background = (x, y, w, h, img) => {
    return Bodies.rectangle(x + w / 2, y + h / 2, w, h, {
        isStatic: true,
        isSensor: true,
        bodyType: "background",
        render: {
            lineWidth: 1,
            sprite: {
                texture: img,
                xOffset: 0,
                yOffset: 0,
                xScale: 1,
                yScale: 1
            }
        }
    })
}

var cookie = (x, y) => {
    return Bodies.rectangle(x, y, 35, 35, {
        isStatic: true,
        isSensor: true,
        bodyType: "cookie",
        render: {
            lineWidth: 1,
            sprite: {
                texture: cookieURL,
                xOffset: 0,
                yOffset: 0,
                xScale: 1,
                yScale: 1
            }
        }
    })
}

var rectangle = (x, y, w, h, img) => {
    return Bodies.rectangle(x + w / 2, y + h / 2, w, h, {
        isStatic: true,
        render: {
            lineWidth: 1,
            sprite: {
                texture: img,
                xOffset: 0,
                yOffset: 0,
                xScale: 1,
                yScale: 1
            }
        }
    })
}

var barrier = (x, y, w, h) => {
    return Bodies.rectangle(x + w / 2, y + h / 2, w, h, {
        isStatic: true,
        render: {
            lineWidth: 1,
            sprite: {
                texture: barrierURL,
                xOffset: 0,
                yOffset: 0,
                xScale: 1,
                yScale: 1
            }
        }
    })
}

var createQuestion = (x, q, a) => {
    var question = Bodies.rectangle(x+55*0.5, 420+180*0.5, 55, 180, {
        isSensor: true,
        isStatic: true,
        bodyType: "question",
        question: q,
        answer: a,
        answered: false,
        render: {
            sprite: {
                texture: questionURL,
                xOffset: 0,
                yOffset: 0,
                xScale: 1,
                yScale: 1
            }
        }
    })
    return question
}

var buildMap = {}
buildMap.rectangle = rectangle
buildMap.build = (composite, world) => {
    composite.add(world, [
        rectangle(0, 424, 5, 168),
        rectangle(20995, 424, 5, 168),
        rectangle(0, 592, 21000, 8),
        rectangle(0, 416, 21000, 8),
        background(0, 0, 21000, 600, scence),
        Bodies.rectangle(680 + 13.5 / 2, 424 + 168 / 2, 13.5, 168, { isSensor: true, isStart: true, render: { sprite: { texture: startURL } } }),
        Bodies.rectangle(20427 + 27 / 2, 424 + 168 / 2, 27, 168, { isSensor: true, isEnd: true, render: { sprite: { texture: endURL } } })
    ])
    // barriers
    composite.add(world, [5485,903, 1835, 2986, 3518, 4352, 4693, 6286, 7798, 8813, 10550, 12345, 13553, 15910, 17913, 19768].map((x) => barrier(x, 435, 14, 60)))
    composite.add(world, [2139,3376,3864,6040,6728,8174,10270,17100,11190,12036,12814,13933,15504,18412,19476].map((x) => barrier(x, 475, 14, 60)))
    composite.add(world, [1351, 18865, 15048, 14353, 12997, 11570, 9781, 8438, 7019, 5634, 4514, 4162, 3165, 2807, 2449, 1351].map((x) => barrier(x, 525, 14, 60)))
    // cookies
    composite.add(world, [
        cookie(1626, 541),
        cookie(2278, 541),
        cookie(2652, 445),
        cookie(4540, 541),
        cookie(5451, 445),
        cookie(7637, 541),
        cookie(9038, 496),
        cookie(11712, 541),
        cookie(12686, 467),
        cookie(14965, 449),
        cookie(16491, 530),
        cookie(17920, 530),
        cookie(18839, 446),
    ])
    // questions
    composite.add(world, [
        createQuestion(1950, "What is UTS's full name?\n\nPlease only enter a single number:\n1. University Technology Services\n2. University of Technology Sydney\n3. Unix Time Stamp", "1"),
        createQuestion(4190, "What is CPS's full name?\n\nPlease only enter a single number:\n1. Canadian Paediatric Society\n2. Collaboration & Productivity Services\n3. Consumer Portfolio Services", "2"),
        createQuestion(8230, "Which building is the highest building at Mac?\n\nPlease only enter a single number:\n1. PGCLL\n2. Brandon Hall\n3. Togo Salmon Hall", "2"),
        createQuestion(10750, "In what year did McMaster relocate to Hamilton?\n\nPlease only enter a single number:\n1. 1935\n2. 1932\n3. 1930", "3"),
        createQuestion(14252, "McMaster's Motto?\n\nPlease only enter a single number:\n1. Wir müssen wissen. Wir werden wissen(We must know, we will know)\n2. ΤΑ ΠΑΝΤΑ ΕΝ ΧΡΙΣΤΩΙ ΣΥΝΕΣΤΗΚΕΝ(In Christ all things hold together)\n3. PRO VERITATEQVE SCIENTIA(For Truth and Knowledge)", "2"),
        createQuestion(16253, "Where is the Original location of McMaster University?\n\nPlease only enter a single number:\n1. Toronto\n2. Ottawa\n3. Hamilton", "1"),
    ])
}
export default buildMap